module.exports = __webpack_public_path__ + "static/media/error.7e0f37a6.svg";